export enum SortingTypes {
  distance = 'distance',
  rating = 'rating',
}
